import { Suspense, lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { Spinner } from '@/components/ui';
import { AuthLayout } from '@/layouts/AuthLayout';
import { DashboardLayout } from '@/layouts/DashboardLayout';
import { PublicRoute } from '@/routes/PublicRoute';
import { ROUTES } from '@/constants';

const LoginPage = lazy(() => import('@/pages/auth/LoginPage'));
const ForgotPasswordPage = lazy(() => import('@/pages/auth/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('@/pages/auth/ResetPasswordPage'));
const DashboardPage = lazy(() => import('@/pages/dashboard/DashboardPage'));
const GerarAtaPage = lazy(() =>
  import('@/features/atas').then((mod) => ({ default: mod.GerarAtaPage })),
);
const NotFoundPage = lazy(() => import('@/pages/errors/NotFoundPage'));

function RouteFallback() {
  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <Spinner />
    </div>
  );
}

/**
 * Template routes.
 * Dashboard shell is public so the foundation can be explored without seeded users.
 * Wrap private product routes with <ProtectedRoute /> when enabling real auth gates.
 */
export function AppRouter() {
  const element = useRoutes([
    {
      element: <PublicRoute />,
      children: [
        {
          element: <AuthLayout />,
          children: [
            { path: ROUTES.LOGIN, element: <LoginPage /> },
            { path: ROUTES.FORGOT_PASSWORD, element: <ForgotPasswordPage /> },
            { path: ROUTES.RESET_PASSWORD, element: <ResetPasswordPage /> },
          ],
        },
      ],
    },
    {
      element: <DashboardLayout />,
      children: [
        { path: ROUTES.DASHBOARD, element: <DashboardPage /> },
        { path: ROUTES.GERAR_ATA, element: <GerarAtaPage /> },
      ],
    },
    { path: ROUTES.HOME, element: <Navigate to={ROUTES.DASHBOARD} replace /> },
    { path: ROUTES.NOT_FOUND, element: <NotFoundPage /> },
  ]);

  return <Suspense fallback={<RouteFallback />}>{element}</Suspense>;
}
